import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-769be652")

_pushScopeId("data-v-769be652")
const _hoisted_1 = { id: "bodyWrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_StartSection = _resolveComponent("StartSection")
  const _component_MainAbout = _resolveComponent("MainAbout")
  const _component_Advantages = _resolveComponent("Advantages")
  const _component_MainInfo = _resolveComponent("MainInfo")
  const _component_JoinSection = _resolveComponent("JoinSection")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_StartSection),
    _createVNode(_component_MainAbout),
    _createVNode(_component_Advantages),
    _createVNode(_component_MainInfo),
    _createVNode(_component_JoinSection),
    _createVNode(_component_Footer)
  ]))
})